import React from 'react';
import {GeoAuthLayout} from '../../layout';
import {SignupForm} from './SignupForm';
import {Box} from '@chakra-ui/layout';

import {useResponsive} from 'utils/useResponsive';
import {HtmlTitle} from 'components/HtmlTitle';
import {useTranslation} from 'modules/i18n';
import {useRecaptcha} from 'utils/recaptcha';
import {Skeleton} from '@chakra-ui/skeleton';

// eslint-disable-next-line
export interface SignupPageProps {}

export const SignupPage: React.FC<SignupPageProps> = () => {
	const {recaptchaLoaded} = useRecaptcha();
	const {isMobile} = useResponsive();

	const {t} = useTranslation();

	return (
		<>
			<HtmlTitle label={t('auth.title.signUp')} />
			<GeoAuthLayout>
				<Skeleton isLoaded={recaptchaLoaded}>
					<Box padding={isMobile ? 1 : 5} w={isMobile ? '100%' : 550}>
						<SignupForm />
					</Box>
				</Skeleton>
			</GeoAuthLayout>
		</>
	);
};
